import { AppService } from 'src/app/services/general/app.service';
import { FunctionService } from 'src/app/services/general/function.service';
import { AccountService } from 'src/app/services/account/account.service';
import { LanguageService } from 'src/app/services/general/language.service';
import { TransactionService } from 'src/app/services/payment/transaction.service';
import { OnlineService } from 'src/app/services/general/online.service';
import { CreditService } from 'src/app/services/subscription/credit.service';
import { AccountsListService } from 'src/app/services/accounts/accounts-list.service';
import { Platform, ModalController } from '@ionic/angular';
import { LinkService } from 'src/app/services/general/link.service';
import { ChangeDetectorRef, Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { ActivatedRoute, Router, Params, NavigationExtras } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { PopupService } from 'src/app/services/general/popup.service';
import { UserAccounts } from 'src/app/interfaces/account';
// import { IAPProduct, InAppPurchase2 } from '@awesome-cordova-plugins/in-app-purchase-2/ngx';
import { AccountProductList } from 'src/app/commons/product';
import { Credit } from 'src/app/interfaces/credit';
import { Product, Price } from 'src/app/interfaces/product';
import { AppStoreReceipt, Item, PaymentRef, PlayStoreReceipt, StripeData } from 'src/app/interfaces/transaction';
import { ErrorService } from 'src/app/services/general/error.service';
import { DeviceService } from 'src/app/services/device/device.service';
import { LocalityService } from 'src/app/services/location/locality.service';
import { TimezoneService } from 'src/app/services/general/timezone.service';
import { CurrencyService } from 'src/app/services/general/currency.service';
import { ProductAccountService } from 'src/app/services/subscription/product-account.service';
import { Voucher } from 'src/app/interfaces/voucher';
import { AccountsSetupComponent } from 'src/app/components/accounts/accounts-setup/accounts-setup.component';
import { VoucherService } from 'src/app/services/subscription/voucher.service';
import { BlastPackageService } from 'src/app/services/blast/blast-package.service';
import { LoginService } from 'src/app/services/general/login.service';
import { AuthService } from 'src/app/services/user/auth.service';
import { UserService } from 'src/app/services/user/user.service';

const PRODUCT_KEY = 'wedding_account_full';

import 'cordova-plugin-purchase';
import { PaymentType } from 'src/app/types/transaction';
import { OnlineDbService } from 'src/app/services/user/online-db.service';

@Component({
  selector: 'app-accounts-premium',
  templateUrl: './accounts-premium.page.html',
  styleUrls: ['./accounts-premium.page.scss'],
})
export class AccountsPremiumPage implements OnInit, OnDestroy
 {
  
  store?: CdvPurchase.Store;
  transaction?: CdvPurchase.Transaction;
  receipt?: CdvPurchase.VerifiedReceipt;

  android: boolean;
  iapMode: boolean;
  /**
   * Product
   */
  product: CdvPurchase.Product;

  accountId: string;

  trialExpired: boolean;
  
  price: Price;

  /**
   * Currency
   */
  currency: string;
  /**
   * Item list
   */
  itemList: Item[];

  specialPromoVoucherId: string;
  specialPromoVoucher: Voucher;

  sellingPrice: Price;
  originalPrice: Price;

  /**
   * Voucher ID
   */
  voucherId: string;
  private referralRate: number;
  /**
   * Referral ID
   */
  private referralCode: string;
  /**
   * Voucher
   */
  voucher: Voucher;
  /**
   * Bulk Mode
   */
  bulkMode: boolean;
  /**
   * Gift Mode
   */
  giftMode: boolean;
  /**
   * Upgrade trial to premium flag
   */
  upgradeTrial: boolean;
  /**
   * Upgrade mode for upgrading to full premium package
   */
  upgradeMode: boolean;
  /**
   * Disable upgrade
   */
  disableUpgrade: boolean;

  disableCreditPrompt: boolean;
  /**
   * Disable bulk mode
   */
  disableBulkMode: boolean;

  backPremiumPage: boolean;

  paymentProcessing: boolean;

  private backAddPage: boolean;

  purchasing: boolean;

  language: string;

  checkIap: boolean

  private userCreditSubscription: Subscription;

  private accountsListSubscription: Subscription;

  private clickCounter: number;
  private approveCounter: number;

  private paymentRef: PaymentRef;

  constructor(
    private platform: Platform,
    private route: ActivatedRoute,
    private router: Router,
    private ref: ChangeDetectorRef,
    // private store: InAppPurchase2,
    private translate: TranslateService,
    private modalController: ModalController,
    private accountsListService: AccountsListService,
    private accountService: AccountService,
    private blastPackageService: BlastPackageService,
    private transactionService: TransactionService,
    private authService: AuthService,
    private userService: UserService,
    private onlineService: OnlineService,
    private appService: AppService,
    private linkService: LinkService,
    private languageService: LanguageService,
    private localityService: LocalityService,
    private deviceService: DeviceService,
    private timezoneService: TimezoneService,
    private creditService: CreditService,
    private voucherService: VoucherService,
    private currencyService: CurrencyService,
    private productAccountService: ProductAccountService,
    private loginService: LoginService,
    private functionService: FunctionService,
    private popupService: PopupService,
    private errorService: ErrorService,
  ) {
  }

  ngOnInit() {
    this.setupProduct();
    this.watchRoute();
  }

  ngOnDestroy(): void {
    this.unwatch();
  }

  watchRoute() {
    this.route.params.subscribe((param: Params) => {
      const route = this.router.getCurrentNavigation();
      const state = route?.extras?.state;

      if (state?.accountId) {
        this.accountId = state?.accountId;
      } else if (param?.accountId) {
        this.accountId = param?.accountId;
      }

      if (state?.currency) {
        this.currency = state?.currency;
      } else if (param?.currency) {
        this.currency = param?.currency;
      }

      if (state?.itemList) {
        this.itemList = state?.itemList;
      } else {
        this.itemList = [];
      }

      if (state?.referralRate) {
        this.referralRate = state.referralRate;
      } else if (param?.referralRate) {
        this.referralRate = param.referralRate;
      }

      if (state?.referralCode && state?.referralCode !== 'null') {
        this.referralCode = state?.referralCode;
      } else if (param?.referralCode && param?.referralCode !== 'null') {
        this.referralCode = param.referralCode;
      } else {
        this.referralCode = '';
      }

      if (state?.voucher) {
        this.voucher = state?.voucher;
      } else {
        this.voucher = null;
      }

      if (state?.voucherId && state?.voucherId !== 'null') {
        this.voucherId = state.voucherId;
      } else if (param?.voucherId && param.voucherId !== 'null') {
        this.voucherId = param.voucherId;
      } else if (this.voucher?.voucherId) {
        this.voucherId = this.voucher.voucherId;
      } else {
        this.voucherId = '';
      }

      if (state?.giftMode) {
        this.giftMode = state.giftMode;
      } else if (param?.giftMode) {
        this.giftMode = param.giftMode;
      } else {
        this.giftMode = false;
      }

      if (state?.bulkMode) {
        this.bulkMode = state?.bulkMode;
      } else if (param?.bulkMode) {
        this.bulkMode = param.bulkMode;
      } else {
        this.bulkMode = false;
      }

      if (state?.upgradeMode) {
        this.upgradeMode = true;
      } else if (param?.upgradeMode) {
        this.upgradeMode = true;
      } else {
        this.upgradeMode = false;
      }

      if (state?.iapMode) {
        this.iapMode = true;
      } else if (param?.iapMode) {
        this.iapMode = true;
      } else {
        this.iapMode = false;
      }

      if (state?.upgradeTrial) {
        this.upgradeTrial = true;
      } else if (param?.upgradeTrial) {
        this.upgradeTrial = true;
      } else {
        this.upgradeTrial = false;
      }

      if (state?.disableUpgrade) {
        this.disableUpgrade = true;
      } else if (param?.disableUpgrade) {
        this.disableUpgrade = true;
      } else {
        this.disableUpgrade = false;
      }

      if (state?.disableCreditPrompt) {
        this.disableCreditPrompt = true;
      } else if (param?.disableCreditPrompt) {
        this.disableCreditPrompt = true;
      } else {
        this.disableCreditPrompt = false;
      }

      if (state?.backPremiumPage) {
        this.backPremiumPage = true;
      } else if (param?.backPremiumPage) {
        this.backPremiumPage = true;
      } else {
        this.backPremiumPage = false;
      }

      if (state?.backAddPage) {
        this.backAddPage = true;
      } else if (param?.backAddPage) {
        this.backAddPage = true;
      } else {
        this.backAddPage = false;
      }

      this.checkAccountId();
      this.watchAccountsList();
    });
  }

  async ionViewWillEnter() {
    await this.platform.ready();
    this.clickCounter = 0;
    this.approveCounter = 0;
    this.purchasing = false;
    this.paymentProcessing = false;
    this.price = {
      currency: this.currencyService.getDeviceCurrency().code,
      amount: 0
    };
    this.language = this.getLanguage();
    this.specialPromoVoucherId = this.getSpecialPromo();
    this.specialPromoVoucher = this.getSpecialVoucherById(this.specialPromoVoucherId);

    this.getProductOriginalPrice();
    this.setupIapMode();
    this.checkProduct();
  }

  ionViewWillLeave() {
    this.unwatch();
  }

  setupIapMode() {
    this.iapMode = false;
    if (this.platform.is('hybrid')) {
      this.android = this.platform.is('android');
      if (this.platform.is('ios')) {
        this.iapMode = true;
      }
    }
  }

  unwatch() {
    this.unwatchUserCredit();
    this.unwatchAccountsList();
  }

  async watchUserCredit() {
    if (!this.userCreditSubscription) {
      this.userCreditSubscription = this.creditService.observableCreditList.subscribe(() => {
        this.checkAvailableCredit();
      });
    }
    
  }

  async unwatchUserCredit() {
    if (this.userCreditSubscription) {
      this.userCreditSubscription.unsubscribe();
      this.userCreditSubscription = null;
    }
  }

  async checkProduct() {
    if (this.platform.is('hybrid') && this.platform.is('ios')) {
      if (!this.product?.id) {
        await this.popupService.presentLoading();
        if (this.product?.id) {
          this.popupService.dismissLoading();
        } else {
          this.checkProductTimeout();
        }
      }
    }
  }

  checkProductTimeout() {
    if (this.product?.id) {
      this.popupService.dismissLoading();
    } else {
      setTimeout(() => {
        this.checkProductTimeout();
      }, 500);
    }
  }

  switchIap() {
    if (!this.iapMode) {
      this.iapMode = true;
    } else {
      this.iapMode = false;
    }
    this.ref.detectChanges();
  }

  checkAvailableCredit() {
    if (!this.disableCreditPrompt) {
      const creditList = this.creditService.getUserAvailableCreditList().filter((credit: Credit) => {
        if (credit?.productId === 'wedding_account_web') {
          return false;
        } else {
          return true;
        }
      });
      if (creditList?.length) {
        this.promptUnusedCredit(creditList);
      }
    }
  }

  async promptUnusedCredit(creditList?: Credit[]) {
    this.disableCreditPrompt = true;
    await this.popupService.dismissLoading();
    const confirm = await this.popupService.presentConfirm(this.translate.instant('CREDIT.msg.unused_credit_reminder'));
    confirm.onDidDismiss().then((result: any) => {
      if (result?.data?.confirm) {
        let goCreditPage = false;
        if (creditList?.length > 1) {
          let productId = '';
          creditList?.forEach((credit: Credit) => {
            if (!productId || productId !== credit.productId) {
              if (productId) {
                goCreditPage = true;
              }
              productId = credit.productId;
            }
          });
        }
        if (goCreditPage) {
          this.goUserCreditPage();
        } else {
          if (this.upgradeTrial && this.accountId) {
            const credit: Credit = this.creditService.getCreditById(creditList[0].creditId);
            this.accountService.upgradeAccountCall(credit, this.accountId, this.upgradeTrial);
          } else {
            this.presentAccountSetupModal(creditList[0].creditId);
          }
        }
      }
    });
  }

  /**
   * Watch Account info
   */
  async watchAccountsList() {
    if (!this.accountsListSubscription) {
      this.accountsListSubscription = this.accountsListService.observableUserAccountsList.subscribe(() => {
        const ownTrialAccountList: UserAccounts[] = this.accountsListService.getOwnTrialAccount();
        if (ownTrialAccountList?.length) {
          const userAccount: UserAccounts = ownTrialAccountList[0];
          this.promptUpgradeTrialAccount(userAccount);
        } else {
          const coupleTrialAccountList: UserAccounts[] = this.accountsListService.getCoupleTrialAccount(true);
          if (coupleTrialAccountList?.length) {
            const userAccount: UserAccounts = coupleTrialAccountList[0];
            this.promptUpgradeTrialAccount(userAccount);
          } else {
            this.watchUserCredit();
          }
        }
      });
    }
    
  }

  /**
   * Unwatch Account info
   */
  async unwatchAccountsList() {
    if (this.accountsListSubscription) {
      this.accountsListSubscription.unsubscribe();
      this.accountsListSubscription = null;
    }
  }

  async checkAccountId() {
    if (!this.accountId && (this.upgradeMode || this.upgradeTrial)) {
      this.accountId = await this.accountService.readAccountId();
    }
    this.checkTrialExpired();
  }

  checkTrialExpired() {
    this.trialExpired = false;
    if (this.upgradeTrial && this.accountId) {
      if (this.accountsListService.checkIsTrialExpired(this.accountId)) {
        this.trialExpired = true;
      }
    }
  }

  async promptUpgradeTrialAccount(userAccount: UserAccounts) {
    if (!this.disableUpgrade && userAccount?.accountId && userAccount?.title?.value && !this.upgradeTrial) {
      if (this.platform.is('ios') && this.platform.is('hybrid') && this.product) {
        this.disableUpgrade = true;
        const modal = await this.popupService.presentConfirm(
          this.translate.instant('ACCOUNT.msg.upgrade_trial', { title: userAccount.title.value })
        );
        modal.onWillDismiss().then(async (result: any) => {
          this.checkTrialExpired();
          if (result?.data?.confirm) {
            if (this.accountsListService.checkIsTrialExpired(userAccount?.accountId)) {
              this.trialExpired = true;
            }
            this.upgradeTrial = true;
            this.accountId = userAccount.accountId;
          } else {
            this.upgradeTrial = false;
          }
          this.watchUserCredit();
        });
      } else {
        setTimeout(() => {
          this.promptUpgradeTrialAccount(userAccount);
        }, 300);
      }
    } else {
      this.watchUserCredit();
    }
  }

  getProductOriginalPrice() {
    const amount = this.productAccountService.getProductPrice('wedding_account_full', this.price.currency, 'original');
    this.price.amount = this.currencyService.rounding(this.price.currency, amount);
  }

  getSellingPrice(product: CdvPurchase.Product): Price {
    const price: Price = {
      amount: product?.pricing?.priceMicros ? (product.pricing.priceMicros / 1000000) : this.getPromoAmount(),
      currency: product?.pricing?.currency ? product.pricing.currency : this.price?.currency ? this.price.currency : this.currencyService.getDeviceCurrency()?.code,
    };
    return price;
  }

  getOriginalPrice(product: CdvPurchase.Product): Price {
    const currency = product?.pricing?.currency ? product.pricing.currency : this.price?.currency ? this.price.currency : this.currencyService.getDeviceCurrency()?.code;
    const price: Price = {
      amount: product?.pricing?.priceMicros ? this.currencyService.rounding(currency, ((product.pricing.priceMicros * 2) / 1000000)) : (this.getPromoAmount() * 2),
      currency,
    };
    return price;
  }

  getPromoAmount() {
    const amount = this.productAccountService.getProductPrice('wedding_account_full', this.price.currency, 'selling');
    return this.currencyService.rounding(this.price.currency, amount * 0.5);
  }

  getSmsPromo() {
    return this.voucherService.getSmsPromo();
  }

  getSpecialPromo(revertStartDays?: number) {
    let voucherId = this.voucherService.getSpecialPromoVoucher(new Date());
    if (!voucherId && revertStartDays) {
      voucherId = this.voucherService.getSpecialPromoVoucher(new Date(), revertStartDays);
    }
    return voucherId;
  }

  getSpecialVoucherById(voucherId: string) {
    return this.voucherService.getSpecialPromoVoucherById(voucherId);
  }

  getLanguage() {
    let language = this.languageService.getUserLanguage()?.code?.toLowerCase();

    return language && language !== 'ms' ? language : 'en';
  }

  /**
   * Present account setup modal
   */
  async presentAccountSetupModal(creditId: string) {
    if (creditId) {
      const modal = await this.modalController.create({
        component: AccountsSetupComponent,
        componentProps: {
          premium: true,
          creditId
        }
      });
      modal.present();
    } else {
      this.popupService.presentActionError();
    }
  }

  generateParam(): NavigationExtras {
    const navigationExtras: NavigationExtras = {
      state: {
        accountId: this.accountId,
        currency: this.currency,
        itemList: this.itemList,
        referralCode: this.referralCode,
        referralRate: this.referralRate,
        voucher: this.voucher,
        voucherId: this.voucherId,
        giftMode: this.giftMode,
        bulkMode: this.bulkMode,
        iapMode: this.iapMode,
        upgradeTrial: this.upgradeTrial,
        upgradeMode: this.upgradeMode,
        disableUpgrade: this.disableUpgrade,
        disableCreditPrompt: this.disableCreditPrompt,
        backPremiumPage: this.backPremiumPage,
        backAddPage: this.backAddPage,
      }
    };
    return navigationExtras;
  }

  goProductAccountPage() {
    this.router.navigate(['/subscription/account'], this.generateParam());
  }

  goAccountAddPage() {
    this.router.navigate(['//tabs-accounts/list']);
  }

  goBack() {
    if (this.backAddPage) {
      this.goAccountAddPage();
    } else {
      this.linkService.goMainPage();
    }
  }

  /**
   * Setup product
   */
  async setupProduct() {
    await this.platform.ready();
    this.checkIap = this.appService.checkIap();

    if (this.platform.is('hybrid') && this.checkIap) {
      this.store = CdvPurchase.store;
      // this.store.verbosity = CdvPurchase.LogLevel.DEBUG;
      this.registerProducts();
      this.setupListeners();
    } else {
      this.popupService.dismissLoading();
    }
  }

  /**
   * Register product
   */
  registerProducts() {
    this.product = this.store?.get(PRODUCT_KEY);
    // this.sellingPrice = this.getSellingPrice(this.product);
    // this.originalPrice = this.getOriginalPrice(this.product);

    if (!this.product?.id) {
      if (this.platform.is('ios')) {
        this.store.register({
          id: PRODUCT_KEY,
          type: CdvPurchase.ProductType.CONSUMABLE,
          platform: CdvPurchase.Platform.APPLE_APPSTORE,
        });
      } else if (this.platform.is('android')) {
        this.store.register({
          id: PRODUCT_KEY,
          type: CdvPurchase.ProductType.CONSUMABLE,
          platform: CdvPurchase.Platform.GOOGLE_PLAY,
        });
      }
      this.store.initialize().then(() => {
        this.getProduct();
      });
    } else {
      this.popupService.dismissLoading();
    }
    // this.store.refresh();
  }

  /**
   * Get product
   */
  getProduct() {
    this.store.ready(async () => {

      this.product = this.store.get(PRODUCT_KEY);
      this.sellingPrice = this.getSellingPrice(this.product);
      this.originalPrice = this.getOriginalPrice(this.product);

      if (this.product?.id) {
        this.ref.detectChanges();
      }
      this.functionService.delay(500);
      this.popupService.dismissLoading();
    });
  }

  getLocalProductInfo() {
    const index = AccountProductList?.findIndex((product: Product) => product.productId === PRODUCT_KEY );
    if (index !== -1) {
      return AccountProductList[index].productName;
    }
    return '';
  }

  /**
   * Get item list
   * @returns Item list
   */
  getItemList(payment: Price): Item[] {
    const itemList: Item[] = [];
    if (payment) {
      const oriPrice: Price = { ...payment };
      const price: Price = { ...payment };
      oriPrice.amount = this.currencyService.rounding(payment.currency, Number((payment.amount * 2)));
      price.amount = this.currencyService.rounding(payment.currency, Number((payment.amount * 2)));
      itemList.push({
        productId: PRODUCT_KEY,
        productType: 'account',
        productName: this.getLocalProductInfo(),
        qty: 1,
        oriPrice,
        price,
        payment,
      });
    }
    return itemList;
  }

  getBlastPriceByCredit(blastCredit: number) {
    const price = this.blastPackageService.calculateBlastPackagePrice(blastCredit);
    return price;
  }

  /**
   * Setup IAP listeners
   */
  setupListeners() {
    this.store.when().approved(async (transaction: CdvPurchase.Transaction) => {
      if (transaction?.products?.[0]?.id === PRODUCT_KEY) {
        this.transaction = transaction;
        if (!this.approveCounter) { this.approveCounter = 0; }
        this.approveCounter += 1;
        await this.functionService.delay(this.functionService.randomNumber(1, 10) * this.approveCounter);
        this.ref.detectChanges();
        transaction.verify();
      } else {
        this.stopPurchasing();
      }
    }).verified(async (receipt: any) => {
      if (this.transaction?.transactionId && receipt?.latestReceipt && receipt?.sourceReceipt?.hasTransaction(this.transaction)) {
        this.receipt = receipt;
        this.approveCounter += 1;
        await this.functionService.delay(this.functionService.randomNumber(1, 10) * this.approveCounter);
        this.createTransaction(this.transaction, this.receipt, this.product); 
      } else {
        this.stopPurchasing();
      }
      receipt.finish();
    }).unverified((t: CdvPurchase.UnverifiedReceipt) => {
      this.stopPurchasing();
    });

    this.store.when().finished((result: any) => {
    });
  }

  async checkUserLogin(product: CdvPurchase.Product) {
    await this.popupService.presentLoading();
    if (this.authService.currentUser) {
      if (this.userService.user?.name) {
        this.purchase(product);
      } else {
        await this.popupService.dismissLoading();
        const modal = await this.loginService.presentUserSetupModal();
        modal.onDidDismiss().then(() => {
          this.purchase(product);
          this.loginService.userSetupModal = null;
        });
      }
    } else {
      this.presentLoginModal(product, false, false);
    }
  }

  async presentLoginModal(product: CdvPurchase.Product, loginRequired?: boolean, showAnonymousLogin?: boolean, linkProvider?: boolean) {
    await this.popupService.dismissLoading();
    const modal = await this.loginService.presentLoginModal(loginRequired, showAnonymousLogin, linkProvider);
    modal.onDidDismiss().then(async () => {
      if (this.userService.user && (showAnonymousLogin || !this.userService?.user?.isAnonymous)) {
        await this.popupService.presentLoading();
        this.purchase(product);
      }
    });
  }

  /**
   * Initial IAP purchase
   * @param product product
   */
  async purchase(product: CdvPurchase.Product) {
    if (product) {
      await this.functionService.delay(this.functionService.randomNumber(20, 100));
      if (!this.clickCounter) { this.clickCounter = 0; }
      this.clickCounter += 1;
      await this.functionService.delay(this.functionService.randomNumber(20, 100) * this.clickCounter);
      if (!this.purchasing) {
        this.purchasing = true;
        await this.popupService.presentLoading(this.translate.instant('LOADING.verify_payment'));

        const offer = this.store.get(PRODUCT_KEY)?.getOffer();
        this.store.order(offer).then((p: any) => {
          if (p?.isError) {
            this.popupService.presentActionError();
            this.stopPurchasing();
          }
        }, (err: any) => {
          console.log('err', err);
          this.errorService.logError(err);
          this.popupService.presentActionError();
          this.stopPurchasing();
        });
      }
    } else {
      this.popupService.presentActionError();
    }
  }

  async stopPurchasing() {
    if (!this.paymentProcessing) {
      await this.functionService.delay(500);
      await this.popupService.dismissLoading();
      this.purchasing = false;
    }
  }

  async restore() {
    await this.popupService.presentLoading();
    setTimeout(() => {
      const creditList: Credit[] = this.creditService.getUserAvailableCreditList();
      if (creditList?.length) {
        if (creditList.length === 1 && creditList?.[0]?.creditId) {
          this.goPaymentResultPage(creditList[0].creditId, this.upgradeMode, this.upgradeTrial, this.accountId, true);
        } else {
          this.goUserCreditPage();
        }
      } else if (this.creditService.getUserUsedCreditCount()) {
        this.popupService.presentAlert(this.translate.instant('IAP.msg.credit_used'));
      } else {
        this.popupService.presentAlert(this.translate.instant('IAP.msg.no_credit'));
      }
      this.popupService.dismissLoading();
    }, 2000);
  }

  /**
   * Create transaction
   * @param product product
   */
  async createTransaction(transaction:any, receipt?: any, product?: CdvPurchase.Product) {
    if (!this.paymentProcessing && transaction?.transactionId && product?.id && ((this.platform.is('ios') && receipt?.id) || (this.platform.is('android') && transaction?.nativePurchase))) {
      this.paymentProcessing = true;
      await this.popupService.presentToast(this.translate.instant('LOADING.verify_payment'), '', false);
      let type: PaymentType = '';
      let detail: StripeData | PlayStoreReceipt | AppStoreReceipt;
      
      if (this.platform.is('ios')) {
        type = 'ios-appstore';
        detail = {
          id: transaction?.transactionId,
          appStoreReceipt: receipt?.sourceReceipt?.nativeData?.appStoreReceipt,
          original_transaction_id: transaction?.transactionId,
          type,
        };
        
      } else if (this.platform.is('android')) {
        type = 'android-playstore';
        detail = {
          id: transaction?.transactionId,
          purchaseState: transaction?.nativePurchase?.purchaseState,
          purchaseToken: transaction?.nativePurchase?.purchaseToken,
          receipt: transaction?.nativePurchase?.receipt,
          signature: transaction?.nativePurchase?.signature,
          type,
        }
      }
      if (type && detail) {
        const paymentRef: PaymentRef = {
          refId: transaction?.transactionId,
          type,
          method: type,
          detail,
        };

        await this.functionService.delay(this.functionService.randomNumber(1, 10) * this.functionService.randomNumber(1, 10));
        if (!this.functionService.isEqual(paymentRef, this.paymentRef)) {
          this.paymentRef = this.functionService.cloneDeep(paymentRef);
          this.disableCreditPrompt = true;
          await this.functionService.delay(this.functionService.randomNumber(1, 10) * this.clickCounter);
          const payment: Price = {
            amount: product?.pricing?.priceMicros ? Number(product.pricing.priceMicros / 1000000) : 0,
            currency: product?.pricing?.currency ? product.pricing.currency : 'SGD',
          };
          const voucher: Voucher = await this.voucherService.getVoucherCall(this.voucherService.getCurrentPromo());
          await this.transactionService.createAccountTransactionCall(
            payment,
            this.getItemList(payment),
            voucher,
            false,
            this.upgradeMode ? true : false,
            this.upgradeTrial ? true : false,
            paymentRef,
            this.languageService.getUserLanguage().code,
            this.localityService.getUserLocality(),
            this.deviceService.deviceInfo.platform,
            this.timezoneService.getUserTimezone(),
            this.accountId
          );
          this.paymentProcessing = false;
          await this.popupService.dismissToast();
          this.ref.detectChanges();
        }
      } else {
        this.paymentProcessing = false;
        await this.popupService.dismissToast();
        this.ref.detectChanges();
      }
    }
  }

  /**
   * Go payment result page
   * @param creditIdList credit id list
   * @param upgradeMode upgrade mode
   * @param accountId Account ID
   */
  goPaymentResultPage(creditId?: string, upgradeMode?: boolean, trialMode?: boolean, accountId?: string, restoreMode?: boolean) {
    const navigationExtras: NavigationExtras = {
      state: {
        result: restoreMode ? 'restore' : 'redeem',
        creditId,
        upgradeMode,
        trialMode,
        accountId,
        disableCreditPrompt: this.disableCreditPrompt,
        disableUpgrade: this.disableUpgrade,
      }
    };
    this.router.navigate(['/subscription/payment-result'], navigationExtras);
  }

  goUserCreditPage() {
    this.router.navigate(['user/credit']);
  }

  async createMissingTransaciton() {
    // const payment = { currency: 'MYR', amount: 119.90 };
    // const voucher: Voucher = await this.voucherService.getVoucherCall(this.voucherService.getCurrentPromo());
    // const paymentRef: PaymentRef = {
    //   refId: '2023101610110000010000TNGOW3',
    //   type: 'ios-appstore',
    //   method: 'ios-appstore',
    //   detail: {
    //     id: '2023101610110000010000TNGOW3',
    //     appStoreReceipt: '2023101610110000010000TNGOW3',
    //     original_transaction_id: '2023101610110000010000TNGOW3',
    //     type: 'ios-appstore',
    //   },
    // };
    // const time = this.functionService.generateTimestamp(new Date('2023-10-16 19:36:31'));

    // await this.transactionService.createAccountTransactionCall(
    //   payment,
    //   this.getItemList(payment),
    //   voucher,
    //   false,
    //   false,
    //   true,
    //   paymentRef,
    //   'en',
    //   { country: 'MY', city: 'Puchong', state: 'Selangor', postalCode: '47180' },
    //   'web',
    //   { label: 'Asia/Kuala Lumpur (UTC+08)', name: 'Asia/Kuala_Lumpur', offset: 480, utc: 'UTC+08:00' },
    //   'AymA2YOPZdGnEItD90ud',
    //   { uid: '4koCT89oCxQTuCXwO6L1AT6Df6B3', uuid: '0AF3439F-BA56-4A4A-9960-7FC3E9461B18', time: this.functionService.firestoreServerTime }
    // );
  }
}
